/**
 *
 */

import React from 'react';
import styled from 'styled-components';
import endPoints from '../../config/endPoints';
import { SubTitle, LandingContainer } from '../../components';

const StyledTrusted = styled.section`
  text-align: center;
  padding: 40px 0px;
  img{
    display:inline-block;
    filter: grayscale(100%);
    @media (max-width: ${({ theme: { breakpoints } }) => breakpoints[2]}) {
      width: 100% !important;
    };
  }
  .slick-dots{
    height: auto;
    bottom: -30px;
    left: 0px;
    text-align: center;
    li{
      background: ${({ theme }) => theme.transparentColor};
      border:${({ theme }) => theme.lightGray} solid 1px;
      width:10px;
      height:10px;
      border-radius:50%;
      cursor:pointer;
      &.slick-active{
        background: ${({ theme }) => theme.transparentColor};
        border:none;
        button{
          background: ${({ theme }) => theme.primaryColor};
          width:10px;
          height:10px;
          border: 2px solid ${({ theme }) => theme.secondaryColor};
          border-radius: 50%;
          &:before{
            color: ${({ theme }) => theme.transparentColor};
          }
        }
      }
      button{
          height:10px;
        &:before{
          color: ${({ theme }) => theme.transparentColor};
        }
      }
    }
  }
`;

function LandingTrusted() {
  return (
    <StyledTrusted>
      <LandingContainer>
        <SubTitle fontWeight="900" className="font-24">Working with Best-In-Class</SubTitle>
        <img src={endPoints.TRUSTED_ICON_NEW.URL} className="width-100" alt={endPoints.TRUSTED_ICON_NEW.ALT} />
      </LandingContainer>
    </StyledTrusted>
  );
}

export default LandingTrusted;



// WEBPACK FOOTER //
// client/containers/NewLanding/Trusted.jsx